// 登録停止フラグ: falseで登録導線が有効化される
// 再度停止する場合は REACT_APP_PUBLIC_TEST_MODE=true を環境変数で設定するか、ここを true にする
export const isTestPublic = false;
